import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { BsEnvelope, BsLink } from "react-icons/bs";

import { Layout, Menu } from "antd";
import Permissions from "../../../utils/permissions";
const { Sider } = Layout;

const Sidebar = (props) => {
  const [openKeys, setOpenKeys] = useState("");
  const location = useLocation();

  const onOpenChange = (options) => {
    setOpenKeys(options[1]);
  };

  return (
    <Sider
      width={236}
      collapsedWidth={0} // completely hide on collapse
      breakpoint="md" // collapse at < 768px
      onBreakpoint={(broken) => {
        setOpenKeys(""); // close menus when switching
      }}
      onCollapse={(collapsed) => {
        console.log("Collapsed:", collapsed);
      }}
    >
      <Menu
        theme="dark"
        openKeys={[openKeys]}
        onOpenChange={onOpenChange}
        selectedKeys={[location.pathname]}
        mode="inline"
      >
        {props?.menuList?.map((item) => {
          const { value, label } = item;
          return (
            <Menu.Item icon={<BsLink />} className="li" key={`/${value}`}>
              <Link to={`/${value}`}> {label ?? "Ticketing Center"}</Link>
            </Menu.Item>
          );
        })}
      </Menu>
    </Sider>
  );
};

export default Sidebar;
